<template>
  <div>
    <div v-if="!this.appLoaded">
      <div class="loader" v-if="!this.appLoaded">
        <div>
          <div class="lds-grid">
            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            <small>Fetching Monthly Prices...</small>
          </div>
        </div>
    </div>
    <div v-if="this.appLoaded">
      <aside id="sidebar-second" class="aside">
        <p>Posting for {{month}}-{{year}}</p>
        <div
          class="block-facets-ajax js-facet-block-id-pricingproducttype contextual-region block-facet--selectize form-control block-facets"
          id="block-pricingproducttype"
        >
          <label class="form-label">Pricing Product Type</label>

          <vue-select
            v-model="selectedProductType"
            :options="filterOptions.productTypes"
            @input="search"
            placeholder="Choose"
          />
        </div>
        <div
          class="block-facets-ajax js-facet-block-id-beveragetype contextual-region block-facet--selectize form-control block-facets"
          id="block-beveragetype"
        >
          <label class="form-label">Beverage Type</label>
          <vue-select
            v-model="selectedBeverageType"
            :options="filterOptions.beverageTypes"
            @input="search"
            placeholder="Choose"
          />
        </div>
        <div
          class="block-facets-ajax js-facet-block-id-brand_2 contextual-region block-facet--selectize form-control block-facets"
          id="block-brand-2"
        >
          <label class="form-label">Brand</label>
          <vue-select
            v-model="selectedBrand"
            :options="filterOptions.brands"
            @input="search"
            placeholder="Choose"
          />
        </div>

        <button class="button button--small button--blue" v-on:click="reset">Reset Form</button>
      </aside>
      <!-- /#sidebar-second -->

      <div class="primary">
        <div
          class="views-element-container contextual-region block-views block-views-block-monthly-price-posting-ny dataTables_wrapper"
          id="block-views-block-monthly-price-posting-ny"
        >
          <div v-if="!this.loading" class="overflow-x dataTables_wrapper">
            <table class="cols-5 data-table dataTable" v-if="rows.length > 0">
              <thead>
                <tr>
                  <th
                    class="views-align-left views-field views-field-nothing-1 views-align-left"
                    id="view-nothing-1-table-column"
                    scope="col"
                  >Product</th>
                  <th
                    class="views-align-left views-field views-field-field-mpp-vintage views-align-left"
                    id="view-field-mpp-vintage-table-column"
                    scope="col"
                  >Vintage</th>
                  <th
                    class="views-align-left views-field views-field-nothing-2 views-align-left"
                    id="view-nothing-2-table-column"
                    scope="col"
                  >Other</th>
                  <th
                    class="views-align-left views-field views-field-nothing-4 views-align-left"
                    id="view-nothing-4-table-column"
                    scope="col"
                  >Number(s)</th>
                  <th
                    class="views-align-left views-field views-field-nothing-6 views-align-left"
                    id="view-nothing-6-table-column"
                    scope="col"
                  >Price(s)</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="row in rows">
                  <tr>
                    <td
                      headers="view-nothing-1-table-column"
                      class="views-field views-field-nothing-1 views-align-left views-field-nothing"
                    >
                      {{ row.title }}
                      <br />
                      Brand: {{ row.field_mpp_brand }}
                      <br />
                      Type: {{ row.field_mpp_beverage_type }}
                    </td>
                    <td
                      headers="view-field-mpp-vintage-table-column"
                      class="views-field views-field-field-mpp-vintage views-align-left"
                    >{{ row.field_mpp_vintage }}</td>
                    <td
                      headers="view-nothing-2-table-column"
                      class="views-field views-field-nothing-2 views-align-left views-field-nothing-3"
                    >
                      Bottles Per Case: {{ row.field_mpp_bottles_per_case }}
                      <br />
                      Size: {{ row.field_mpp_size }}
                      <br />
                      Alcohol Content: {{ row.field_mpp_alcohol_content }}
                      <br />
                    </td>
                    <td
                      headers="view-nothing-4-table-column"
                      class="views-field views-field-nothing-4 views-align-left views-field-nothing-5"
                    >
                      Item: {{ row.field_mpp_wholesaler_item_number}}
                      <br />
                      TTB: {{ row.field_mpp_ttb_number}}
                    </td>
                    <td
                      headers="view-nothing-6-table-column"
                      class="views-field views-field-nothing-6 views-align-left views-field-nothing-7"
                    >
                      Case: {{ currencyFormatter(row.field_mpp_case_price) }}
                      <br />
                      Bottle: {{ currencyFormatter(row.field_mpp_per_bottle_price) }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div class="loader" v-if="this.loading">
            <div>
              <div class="lds-grid">
                <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                <small>Fetching Prices...</small>
              </div>
            </div>
          <div class="dataTables_paginate paging_full" id="price-posting-table_paginate">
            <h4 id="pagination-heading" class="visually-hidden">Pagination</h4>
            <button
              class="paginate_button"
              v-if="hasPreviousPage"
              v-on:click="goToPreviousPage"
            >Previous Page</button>
            <button class="paginate_button" v-if="hasNextPage" v-on:click="goToNextPage">Next Page</button>
          </div>

          <footer>
            <div
              class="dataTables_info"
              id="distribution-data-table_info"
              role="status"
              aria-live="polite"
            >{{ from + 1 }} - {{ pageEndIndex }} of {{ numResultsTotal  }}</div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// This is a bug fix for https://github.com/sagalbot/vue-select/issues/814, Replace when version has been updated. If you need to change this you need to build from src
import {VueSelect} from "./components/vue-select/dist/vue-select.js";
// import vSelect from "vue-select";
import "./components/vue-select/dist/vue-select.css";

const serviceUrl =
  "https://ukvglryeug.execute-api.us-east-1.amazonaws.com/production/";

export default {
  name: "app",
  components: {
    VueSelect
  },
  beforeMount() {
    this.appLoaded = false;
  },
  mounted() {
    let today = new Date();
    this.$data.month = ("0" + (today.getMonth() + 1)).slice(-2);
    this.$data.year = today.getFullYear();

    this.appLoaded = true;
    // Get facets list
    this.populateFacetOptions();
    // Do initial search
    this.search();
  },
  data() {
    return {
      month: null,
      year: null,
      filterOptions: {
        brands: [],
        productTypes: [],
        beverageTypes: []
      },
      selectedBrand: null,
      selectedProductType: null,
      selectedBeverageType: null,
      from: 0,
      size: 25,
      numResultsTotal: 0,
      loading: false,
      appLoaded: true,
      rows: []
    };
  },
  methods: {
    populateFacetOptions() {
    console.log('================================================');
    console.log('BLUE ROVER', serviceUrl + "facets");
    console.log('BLUE ROVER BODY', this.postBody);
    console.log('================================================');

      axios
        .post(serviceUrl + "facets", this.postBody)
        .then(resp => {
          let productTypes = [];
          let beverageTypes = [];
          let brands = [];

    console.log('================================================');
    console.log('BLUE ROVER RESP', resp);
    console.log('================================================');

          if (resp.data && resp.data.hasOwnProperty("payload")) {
            if (resp.data.payload.hasOwnProperty("aggregations")) {
              // Handle Brands
              if (
                resp.data.payload.aggregations.hasOwnProperty("field_mpp_brand")
              ) {
                if (
                  resp.data.payload.aggregations.field_mpp_brand.hasOwnProperty(
                    "buckets"
                  )
                ) {
                  //iterate over the brands
                  for (let facet of resp.data.payload.aggregations
                    .field_mpp_brand.buckets) {
                    brands.push(facet.key);
                  }
                }
              }

              // Handle ProductTypes
              if (
                resp.data.payload.aggregations.hasOwnProperty(
                  "field_mpp_pricing_product_type"
                )
              ) {
                if (
                  resp.data.payload.aggregations.field_mpp_pricing_product_type.hasOwnProperty(
                    "buckets"
                  )
                ) {
                  //iterate over the field_mpp_pricing_product_type
                  for (let facet of resp.data.payload.aggregations
                    .field_mpp_pricing_product_type.buckets) {
                    productTypes.push(facet.key);
                  }
                }
              }

              // Handle ProductTypes
              if (
                resp.data.payload.aggregations.hasOwnProperty(
                  "field_mpp_beverage_type"
                )
              ) {
                if (
                  resp.data.payload.aggregations.field_mpp_beverage_type.hasOwnProperty(
                    "buckets"
                  )
                ) {
                  //iterate over the field_mpp_pricing_product_type
                  for (let facet of resp.data.payload.aggregations
                    .field_mpp_beverage_type.buckets) {
                    beverageTypes.push(facet.key);
                  }
                }
              }
            }

            // The total number of results for this facet set.
            if (
              resp.data.payload.hasOwnProperty("hits") &&
              resp.data.payload.hits.hasOwnProperty("total")
            ) {
              this.numResultsTotal = resp.data.payload.hits.total;
            }

            brands.sort((a, b) => (a > b ? 1 : -1));
            beverageTypes.sort((a, b) => (a > b ? 1 : -1));
            productTypes.sort((a, b) => (a > b ? 1 : -1));

            this.filterOptions["brands"] = brands;
            this.filterOptions["beverageTypes"] = beverageTypes;
            this.filterOptions["productTypes"] = productTypes;
          }
        })
        .catch(err => {
          // console.log(err);
        });
    },
    search() {
      this.loading = true;

      // Build request body
      let body = this.postBody;
      body.from = this.from;
      body.size = this.size;

      // Recalculate the facets options.
      this.populateFacetOptions();

      // Search
    console.log('================================================');
    console.log('GREEN ROVER', serviceUrl + "search");
    console.log('GREEN ROVER BODY', body);
    console.log('================================================');

      axios
        .post(serviceUrl + "search", body)
        .then(resp => {
    console.log('================================================');
    console.log('GREEN ROVER RESP', resp);
    console.log('================================================');

          let rows = [];
          if (resp.data.hasOwnProperty("payload")) {
            if (resp.data.payload.hasOwnProperty("hits")) {
              // Handle Property Types
              if (resp.data.payload.hits.hasOwnProperty("hits")) {
                //iterate over the location types
                for (let tmp of resp.data.payload.hits.hits) {
                  // extract and reform each location
                  const { _id: id, _source: source } = tmp;
                  rows.push({
                    id: id,
                    title: source.title,
                    field_mpp_brand: source.field_mpp_brand,
                    field_mpp_beverage_type: source.field_mpp_beverage_type,
                    field_mpp_vintage: source.field_mpp_vintage,
                    field_mpp_bottles_per_case:
                      source.field_mpp_bottles_per_case,
                    field_mpp_size: source.field_mpp_size,
                    field_mpp_alcohol_content: source.field_mpp_alcohol_content,
                    field_mpp_wholesaler_item_number:
                      source.field_mpp_wholesaler_item_number,
                    field_mpp_ttb_number: source.field_mpp_ttb_number,
                    field_mpp_case_price: source.field_mpp_case_price,
                    field_mpp_per_bottle_price:
                      source.field_mpp_per_bottle_price
                  });
                }
              }
            }
          }

          this.rows = rows;
          this.loading = false;
        })
        .catch(err => {
          this.rows = [];
          this.loading = false;
        });
    },
    currencyFormatter(value) {
      return Number(value).toLocaleString("en-US", {
        style: "currency",
        currency: "USD"
      });
    },
    goToNextPage() {
      this.from = this.from + this.rows.length;
      // Do initial search
      this.search();
    },
    goToPreviousPage() {
      this.from = this.from - this.size;
      if (this.from < 0) {
        this.from = 0;
      }
      // Do initial search
      this.search();
    },
    reset() {
      this.from = 0;
      this.selectedBrand = null;
      this.selectedProductType = null;
      this.selectedBeverageType = null;

      // Do initial search
      this.search();
    }
  },
  computed: {
    postBody() {
      let postBody = {
        month: this.$data.month,
        year: this.$data.year
      };
      if (this.$data.selectedBrand != null) {
        postBody["brand"] = this.$data.selectedBrand;
      }
      if (this.$data.selectedProductType != null) {
        postBody["product_type"] = this.$data.selectedProductType;
      }
      if (this.$data.selectedBeverageType != null) {
        postBody["beverage_type"] = this.$data.selectedBeverageType;
      }
      return postBody;
    },
    pageEndIndex() {
      let endIndex = this.from + this.size;
      if (endIndex > this.numResultsTotal) {
        endIndex = this.numResultsTotal;
      }
      if (endIndex <= this.from) {
        this.from = 0;
        this.search();
      }
      return endIndex;
    },
    hasNextPage() {
      if (this.numResultsTotal - (this.from + this.rows.length) > 0) {
        return true;
      }

      return false;
    },
    hasPreviousPage() {
      if (this.from > 0) {
        return true;
      }

      return false;
    }
  }
};
</script>

<style lang="scss">
.v-select {
  .vs__selected {
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.3);
    font-family: "TransatBold", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 0.875rem;
    line-height: 1;
    border-radius: 4px;
    background-color: #002d72;
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.2),
      inset 0 1px rgba(255, 255, 255, 0.03);
    background-image: none;
    cursor: pointer;
    margin: 0;
    padding: 2px 6px;
    background: #002d72;
    color: #ffffff;
    border: 1px solid #00193f;
  }

  .vs__dropdown-toggle {
    border: 1px solid #d6d6d6;
    display: flex;
    overflow: hidden;
    position: relative;
    z-index: 1;
    width: 100%;
    // padding: 0.45rem 1rem;
    padding: 6px 3px;
    font-size: 1rem;
    color: #32393d;
    background-color: #ffffff;
    border-radius: 4px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1) inset;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    box-sizing: border-box;
    background: #ffffff;
    cursor: text;
    color: #32393d;
    font-family: inherit;
    font-size: 1rem;
    min-height: 40px;
    line-height: 23px;
    -webkit-font-smoothing: inherit;
  }

  .vs__open-indicator {
    display: none;
  }

  .vs__actions {
    display: flex;
    align-items: center;
    padding: 4px 6px 0 3px;
  }

  .vs__search {
    margin: 0;
  }

  .vs__dropdown-option {
    padding: 3px 10px;
  }

  .vs__dropdown-option--highlight {
    background-color: #f2f2f2;
    color: #32393d;
  }

  .vs__dropdown-menu {
    list-style-type: none;
    li {
      list-style: none;
      font-size: 14px;
      &:before {
        content: "";
      }
    }
  }

  input[type="search"] {
    background-image: none;
  }

  .vs__clear {
    margin-right: 0;
  }
}
.loader {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: center;
  height: 50vh;

  small {
    display: block;
  }
}
.lds-grid {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-grid div {
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #002d72;
  animation: lds-grid 1.2s linear infinite;
}
.lds-grid div:nth-child(1) {
  top: 8px;
  left: 8px;
  animation-delay: 0s;
}
.lds-grid div:nth-child(2) {
  top: 8px;
  left: 32px;
  animation-delay: -0.4s;
}
.lds-grid div:nth-child(3) {
  top: 8px;
  left: 56px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(4) {
  top: 32px;
  left: 8px;
  animation-delay: -0.4s;
}
.lds-grid div:nth-child(5) {
  top: 32px;
  left: 32px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(6) {
  top: 32px;
  left: 56px;
  animation-delay: -1.2s;
}
.lds-grid div:nth-child(7) {
  top: 56px;
  left: 8px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(8) {
  top: 56px;
  left: 32px;
  animation-delay: -1.2s;
}
.lds-grid div:nth-child(9) {
  top: 56px;
  left: 56px;
  animation-delay: -1.6s;
}
@keyframes lds-grid {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue